import React, { useState } from 'react';
import { registerUser } from '../api';
import { Link, useNavigate } from 'react-router-dom';
import './Auth.css';

function RegisterPage({ onLogout }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const navigate = useNavigate();

    const handleRegister = async () => {
        setErrorMsg('');
        setSuccessMsg('');
        const res = await registerUser(username, password);
        console.log('Register response:', res);

        if (res.message === 'Registration successful') {
            onLogout();
            setSuccessMsg('Регистрация успешна! Сейчас вы будете перенаправлены к логину.');
            setTimeout(() => navigate('/login'), 800);
            return;
        }
        setErrorMsg(res.message || 'Ошибка регистрации');
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <h2>Регистрация</h2>
                <p className="auth-subtitle">
                    Создайте аккаунт для оформления заказов
                </p>

                <div className="input-group">
                    <input
                        type="text"
                        placeholder="Имя пользователя"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />
                </div>

                <div className="input-group">
                    <input
                        type="password"
                        placeholder="Пароль"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                </div>

                {errorMsg && <div className="error-msg">{errorMsg}</div>}
                {successMsg && <div className="success-msg">{successMsg}</div>}

                <button className="auth-btn" onClick={handleRegister}>
                    Зарегистрироваться
                </button>

                <div className="switch-auth">
                    Уже есть аккаунт? <Link to="/login">Войти</Link>
                </div>
            </div>
        </div>
    );
}

export default RegisterPage;